import { useCallback, useEffect } from 'react';
export function useSensor(onClickOutside, onEscape, ref) {
    const handleClickEvent = useCallback((e) => {
        if (!ref.current)
            return;
        if (e instanceof MouseEvent &&
            e.target instanceof Element &&
            !ref.current.contains(e.target)) {
            onClickOutside(e);
        }
    }, [onClickOutside, ref]);
    const handleKeyboardEvent = useCallback((e) => {
        if (!ref?.current)
            return;
        if (e instanceof KeyboardEvent && e.key === 'Escape') {
            onEscape();
        }
    }, [onEscape, ref]);
    useEffect(() => {
        document.addEventListener('mousedown', handleClickEvent, true);
        document.addEventListener('keydown', handleKeyboardEvent, true);
        return () => {
            document.removeEventListener('mousedown', handleClickEvent, true);
            document.removeEventListener('keydown', handleKeyboardEvent, true);
        };
    }, [handleKeyboardEvent, handleClickEvent]);
}
//# sourceMappingURL=use_sensor.js.map